import _slicedToArray from "/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/helpers/esm/inherits";
import { BaseClient, BaseResponse } from './base';
import { AbortError } from '../../utils';
var XHRResponse = /*#__PURE__*/function (_BaseResponse) {
  _inherits(XHRResponse, _BaseResponse);
  /**
   * BaseResponse facade for XMLHttpRequest
   * @param {XMLHttpRequest} xhr
   * @param {ArrayBuffer} data
   */
  function XHRResponse(xhr, data) {
    var _this;
    _classCallCheck(this, XHRResponse);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(XHRResponse).call(this));
    _this.xhr = xhr;
    _this.data = data;
    return _this;
  }
  _createClass(XHRResponse, [{
    key: "getHeader",
    value: function getHeader(name) {
      return this.xhr.getResponseHeader(name);
    }
  }, {
    key: "getData",
    value: function () {
      var _getData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.data);
              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getData() {
        return _getData.apply(this, arguments);
      }
      return getData;
    }()
  }, {
    key: "status",
    get: function get() {
      return this.xhr.status;
    }
  }]);
  return XHRResponse;
}(BaseResponse);
export var XHRClient = /*#__PURE__*/function (_BaseClient) {
  _inherits(XHRClient, _BaseClient);
  function XHRClient() {
    _classCallCheck(this, XHRClient);
    return _possibleConstructorReturn(this, _getPrototypeOf(XHRClient).apply(this, arguments));
  }
  _createClass(XHRClient, [{
    key: "constructRequest",
    value: function constructRequest(headers, signal) {
      var _this2 = this;
      return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', _this2.url);
        xhr.responseType = 'arraybuffer';
        for (var _i = 0, _Object$entries = Object.entries(headers); _i < _Object$entries.length; _i++) {
          var _ref3 = _Object$entries[_i];
          var _ref2 = _slicedToArray(_ref3, 2);
          var key = _ref2[0];
          var value = _ref2[1];
          xhr.setRequestHeader(key, value);
        }

        // hook signals
        xhr.onload = function () {
          var data = xhr.response;
          resolve(new XHRResponse(xhr, data));
        };
        xhr.onerror = reject;
        xhr.onabort = function () {
          return reject(new AbortError('Request aborted'));
        };
        xhr.send();
        if (signal) {
          if (signal.aborted) {
            xhr.abort();
          }
          signal.addEventListener('abort', function () {
            return xhr.abort();
          });
        }
      });
    }
  }, {
    key: "request",
    value: function () {
      var _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _ref4,
          headers,
          signal,
          response,
          _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _ref4 = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {}, headers = _ref4.headers, signal = _ref4.signal;
                _context2.next = 3;
                return this.constructRequest(headers, signal);
              case 3:
                response = _context2.sent;
                return _context2.abrupt("return", response);
              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function request() {
        return _request.apply(this, arguments);
      }
      return request;
    }()
  }]);
  return XHRClient;
}(BaseClient);